import { findAction, findActionIn, invokeAction } from 'actions';
export class MyProfileError extends Error {
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MyProfileError';
    }
}
export async function fetchMyProfile(user) {
    const action = findAction(user, 'myProfile');
    if (!action) {
        throw new MyProfileError('no-action', 'myProfile action is not available');
    }
    let response;
    try {
        response = await invokeAction(action, user.token);
    }
    catch (cause) {
        throw new MyProfileError('network', 'myProfile fetch failed');
    }
    if (!response.ok) {
        throw new MyProfileError('http', `myProfile fetch returned ${response.status}`);
    }
    return response.json();
}
export async function editMyProfile(profile, user, body) {
    const editAction = findActionIn(profile.object?.potentialAction, 'edit');
    if (!editAction) {
        throw new MyProfileError('no-edit-action', 'myProfile.edit action is not available');
    }
    let response;
    try {
        response = await invokeAction(editAction, user.token, { body });
    }
    catch (cause) {
        throw new MyProfileError('network', 'myProfile.edit failed');
    }
    if (!response.ok) {
        throw new MyProfileError('http', `myProfile.edit returned ${response.status}`);
    }
}
